// New TokenTypes are to be added to the end of the list. Do not change the order.
export var AuthTokenType;
(function (AuthTokenType) {
    AuthTokenType[AuthTokenType["EditorLowPrivilege"] = 0] = "EditorLowPrivilege";
    AuthTokenType[AuthTokenType["AugLoopLowPrivilege"] = 1] = "AugLoopLowPrivilege";
    AuthTokenType[AuthTokenType["Anonymous"] = 2] = "Anonymous";
    AuthTokenType[AuthTokenType["ClientAssertion"] = 3] = "ClientAssertion";
    AuthTokenType[AuthTokenType["ClientAssertionV2"] = 4] = "ClientAssertionV2";
    AuthTokenType[AuthTokenType["AutoClpLowPrivilege"] = 5] = "AutoClpLowPrivilege";
    AuthTokenType[AuthTokenType["AutoClpAppOnlyLowPrivilege"] = 6] = "AutoClpAppOnlyLowPrivilege";
    AuthTokenType[AuthTokenType["Substrate"] = 7] = "Substrate";
    AuthTokenType[AuthTokenType["WacUserInfo"] = 8] = "WacUserInfo";
    AuthTokenType[AuthTokenType["OwaExchange"] = 9] = "OwaExchange";
    AuthTokenType[AuthTokenType["SmartCompose"] = 10] = "SmartCompose";
    AuthTokenType[AuthTokenType["WritingAnalyticsLowPrivilege"] = 11] = "WritingAnalyticsLowPrivilege";
    AuthTokenType[AuthTokenType["DWEngineLowPrivilege"] = 12] = "DWEngineLowPrivilege";
    AuthTokenType[AuthTokenType["SubstrateApp"] = 13] = "SubstrateApp";
    AuthTokenType[AuthTokenType["CortanaAppPop"] = 14] = "CortanaAppPop";
    AuthTokenType[AuthTokenType["OfficeAppsAppOnly"] = 15] = "OfficeAppsAppOnly";
    AuthTokenType[AuthTokenType["PPTFrontdoorAppPop"] = 16] = "PPTFrontdoorAppPop";
    AuthTokenType[AuthTokenType["EditorAppOnlyLowPrivilege"] = 17] = "EditorAppOnlyLowPrivilege";
    AuthTokenType[AuthTokenType["AugLoopApp"] = 18] = "AugLoopApp";
    AuthTokenType[AuthTokenType["MeetingIntelligenceApp"] = 19] = "MeetingIntelligenceApp";
    AuthTokenType[AuthTokenType["GraphApp"] = 20] = "GraphApp";
    AuthTokenType[AuthTokenType["IceServicesApp"] = 21] = "IceServicesApp";
    AuthTokenType[AuthTokenType["AzureMapsApp"] = 22] = "AzureMapsApp";
    AuthTokenType[AuthTokenType["SpoApp"] = 23] = "SpoApp";
    AuthTokenType[AuthTokenType["OneDrive"] = 24] = "OneDrive";
    AuthTokenType[AuthTokenType["GoogleDrive"] = 25] = "GoogleDrive";
    AuthTokenType[AuthTokenType["GettyApp"] = 26] = "GettyApp";
})(AuthTokenType || (AuthTokenType = {}));
export var UserType;
(function (UserType) {
    UserType[UserType["Unknown"] = 0] = "Unknown";
    UserType[UserType["Consumer"] = 1] = "Consumer";
    UserType[UserType["Enterprise"] = 2] = "Enterprise";
})(UserType || (UserType = {}));
/**
 * OAuth 2.0 authorization grant flow
 * @codegen
 */
export var OAuth2GrantFlow;
(function (OAuth2GrantFlow) {
    OAuth2GrantFlow["AuthorizationCode"] = "authorization_code";
    OAuth2GrantFlow["ClientCredentials"] = "client_credentials";
})(OAuth2GrantFlow || (OAuth2GrantFlow = {}));
/**
 * The scope for the app registered in the identity provider
 * @codegen
 */
export var OAuth2AppScope;
(function (OAuth2AppScope) {
    OAuth2AppScope[OAuth2AppScope["DesignerApp"] = 0] = "DesignerApp";
})(OAuth2AppScope || (OAuth2AppScope = {}));
//# sourceMappingURL=authTypes.js.map